import { View } from '../base/View';
export class NotifyView extends View {
    constructor(container, actions) {
        super(container);
        this._text = container.querySelector('.notify__description');
        this._buttons = container.querySelector('.notify__buttons');
        this._buttonClose = container.querySelector('.notify__close');
        this._buttonConfirm = container.querySelector('.notify__confirm');
        if (this._buttonClose && (actions === null || actions === void 0 ? void 0 : actions.onClick)) {
            this._buttonClose.addEventListener('click', actions.onClick);
        }
        if (this._buttonConfirm && (actions === null || actions === void 0 ? void 0 : actions.onClickConfirm)) {
            this._buttonConfirm.addEventListener('click', actions.onClickConfirm);
        }
    }
    set text(value) {
        if (value) {
            this.setVisible(this._text);
            this.setText(this._text, value);
        }
        else {
            this.setHidden(this._text);
        }
    }
    set buttonsVisible(value) {
        if (this._buttons) {
            if (value) {
                this.setVisible(this._buttons);
            }
            else {
                this.setHidden(this._buttons);
            }
        }
    }
    set buttonText(value) {
        this.setText(this._buttonClose, value);
    }
}
